/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import PluginInputMask from "../plugins/input-mask";
// import PluginLottie from "../plugins/lottie";
import PluginCounter from "../plugins/counter";
import PluginPopover from "../plugins/popover";
import PluginScrollbar from "../plugins/scrollbar";
import PluginNoUiSlider from "../plugins/nouislider";

let Plugins = {};
Plugins.nouislider = PluginNoUiSlider;
Plugins.floatinglabel = require('./../plugins/floating-label');
Plugins.tooltipster = require('./../plugins/tooltipster');
Plugins.socialSharer = require('./../plugins/social-sharer');
Plugins.inputMask = PluginInputMask;
// Plugins.lottie = PluginLottie;
Plugins.counter = PluginCounter;
Plugins.popover = PluginPopover;
Plugins.scrollBar = PluginScrollbar;

export default Plugins;
